import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path d="M20 7H15V2L20 7Z" fill="currentColor" />
    <path
      d="M14 8V2H6.286C5.023 2 4 2.895 4 4V20C4 21.105 5.023 22 6.286 22H17.715C18.977 22 20 21.105 20 20V8H14ZM12 18L9 14H11V11H13V14H15L12 18Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'FileGeneric');

export default Icon;
